<ng-select
  #autoComplete
  [items]="searchResults$ | async"
  [addTag]="false"
  [multiple]="false"
  [hideSelected]="false"
  [loading]="searchLoading"
  [typeahead]="searchInput$"
  [appendTo]="'body'"
  [placeholder]="'settings.search-by-product-name-or-sku' | translate"
  [ngModel]="selected"
  (change)="selectResult($event)"
>
  <ng-template ng-option-tmp let-item="item">
    <img
      style="width: 48px;height: 48px;"
      *ngIf="item.product.featuredAsset; else imagePlaceholder"
      [src]="item.product.featuredAsset.preview"
    />
    <ng-template #imagePlaceholder>
      <div style="display: inline-block" class="placeholder">
        <clr-icon shape="image" size="48"></clr-icon>
      </div>
    </ng-template>
    {{ item.name }}
    <small class="sku">{{ item.sku }}</small>
  </ng-template>
</ng-select>
